@use '@/styles/tokens' as *;

.picker {
  width: 100%;

  &:hover:not(:global(.ant-picker-disabled)) {
    box-shadow: var(--shadow-field-hover);
  }

  :global(.ant-picker-input) > input::placeholder {
    color: var(--overlay-20);
  }
}

.popup {
  :global(.ant-picker-panel-container) {
    border-radius: 14px;
    box-shadow: var(--shadow-overlay);
  }

  :global(.ant-picker-cell-inner) {
    border-radius: 8px;
    font-family: $font-family-base;
  }

  :global(.ant-picker-cell-selected .ant-picker-cell-inner) {
    background: $color-neutral-950;
    color: $color-neutral-50;
  }

  :global(.ant-picker-cell-in-range .ant-picker-cell-inner) {
    background: $color-neutral-100;
  }
}
